var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "one-off-reasons flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Select one-off reason\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("span", { staticClass: "flex-shrink description" }, [
            _vm._v("\n      Please select a reason for product one-off.\n    "),
          ]),
          _vm._v(" "),
          _c("RefreshButton", {
            staticClass: "flex-shrink",
            staticStyle: { padding: "0", "margin-left": "0.5rem" },
            attrs: { text: false },
            on: { click: _vm.loadReasons },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-row gap-16" }, [
          _c(
            "div",
            { staticClass: "select-one-off-reason" },
            [
              _c(
                "el-select",
                {
                  staticClass: "reason-group-select",
                  attrs: {
                    placeholder: _vm.selectedReasonGroup.toString(),
                    "popper-class": "select-one-off-reason-dropdown",
                  },
                  on: { change: _vm.sendReasonGroup },
                  model: {
                    value: _vm.selectedReasonGroup,
                    callback: function ($$v) {
                      _vm.selectedReasonGroup = $$v
                    },
                    expression: "selectedReasonGroup",
                  },
                },
                _vm._l(_vm.reasonGroups, function (group) {
                  return _c(
                    "el-option",
                    {
                      key: group.id,
                      staticClass: "select-one-off-reason-option",
                      attrs: { label: group.value, value: group.id },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "highlight-selection":
                              _vm.selectedReasonGroup === group.id,
                          },
                          staticStyle: { float: "left", color: "#424242" },
                        },
                        [_vm._v(_vm._s(group.value))]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-row gap-16" }, [
          _c(
            "div",
            { staticClass: "select-one-off-reason" },
            [
              _c(
                "el-select",
                {
                  staticClass: "reason-group-select",
                  attrs: {
                    value: _vm.reasonSelectionText,
                    disabled: !_vm.isGroupSelected,
                    placeholder: "Select the one-off reason",
                    "popper-class": "select-one-off-reason-dropdown",
                  },
                  on: { change: _vm.sendReason },
                },
                _vm._l(_vm.oneOffReasons, function (reason) {
                  return _c(
                    "el-option",
                    {
                      key: reason.id,
                      staticClass: "select-one-off-reason-option",
                      attrs: { label: reason.text, value: reason.id },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "highlight-selection":
                              _vm.selectedOneOffReason === reason.id,
                          },
                          staticStyle: { float: "left", color: "#424242" },
                        },
                        [
                          _vm._v(
                            _vm._s(reason.value) +
                              " - " +
                              _vm._s(reason.text) +
                              " "
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: reason.return_label,
                                  expression: "reason.return_label",
                                },
                              ],
                              staticStyle: { color: "#6e6e6e !important" },
                            },
                            [_vm._v("With Return Label")]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c(
        "div",
        {
          staticClass: "flex-1 input-label",
          staticStyle: { "margin-top": "48px", "margin-bottom": "8px" },
        },
        [_vm._v("\n        Reason Group\n      ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c(
        "div",
        {
          staticClass: "flex-1 input-label",
          staticStyle: { "margin-top": "40px", "margin-bottom": "8px" },
        },
        [_vm._v("\n        One-off Reason\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }